import {Bundle, useFullOpenTransfersForTruck, watchBundleByIdTqo} from "../rpc/webrpc-client.gen.ts";
import {useQueries} from "@tanstack/react-query";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {mergeUseQueriesWithInfill} from "../tq/mergeUseQueriesWithInfill.tsx";
import {cleanse, NADA} from "../util/arutil.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function useLoadedBundles(args ?: { truckId: string }): InfallibleUseResult<Bundle[]> {
    const mama = useMothership();
    const transferTqrv = useFullOpenTransfersForTruck(args);
    const bundlesTqrv = useQueries(transferTqrv.data
        ? {
            queries: cleanse(transferTqrv.data).map(xfer =>
                watchBundleByIdTqo(mama, {bundleId: xfer.bundle.id})),
            combine: mergeUseQueriesWithInfill,
        } : {queries: NADA});

    if (transferTqrv.isPending || bundlesTqrv.isPending) {
        return pendingUseResult;
    }

    return successUseResult(cleanse(bundlesTqrv.data));
}